export const ACTIONS = {
  SET_MEDIA_PROVIDER: 'SET_MEDIA_PROVIDER',
  CLEAR_MEDIA_PROVIDER: 'CLEAR_MEDIA_PROVIDER',
};

export const setMediaProvider = payload => ({
  type: ACTIONS.SET_MEDIA_PROVIDER,
  payload,
});

export const clearMediaProvider = () => ({
  type: ACTIONS.CLEAR_MEDIA_PROVIDER,
  payload: {},
});
